<div class="row m-0">
    <div class="col-sm-12 nav d-flex justify-content-between">
        <a href="javascript:void(0)" class="firstAgenda"><i class="fa fa-caret-left" aria-hidden="true"></i><i
                class="fa fa-caret-left" aria-hidden="true"></i> Agenda</a>
        <a (click)="showBack()" href="javascript:void(0)" class="back" style="display:none;"><i class="fa fa-caret-left"
                aria-hidden="true"></i><i class="fa fa-caret-left" aria-hidden="true"></i> Agenda</a>


        <span *ngFor="let agenda of agendaObject || []; let i = index;" id="content-{{+i}}" attr.data-id='{{+i + 1}}'
            [ngStyle]="{'display': i == this.currentAgendaOnDisplay ? 'block' : 'none' }">
            <div *ngIf="agenda && agenda.AgendaGenerationPdf && agenda.AgendaGenerationPdf.length >= 1">
                <a href="javascript:void(0)" (click)="initiateUploadAgendaPdf(agenda)" id="openAttachment-{{i}}">
                    <i class="fa fa-paperclip" aria-hidden="true"></i> {{agenda.AgendaGenerationPdf.length}}
                </a>
            </div>
        </span> 
        

        <a (click)="showNext()" href="javascript:void(0)" class="next" >Agenda <i class="fa fa-caret-right"
                aria-hidden="true"></i><i class="fa fa-caret-right" aria-hidden="true"></i></a>
        <a href="javascript:void(0)" class="lastAgenda" style="display:none;">Agenda <i class="fa fa-caret-right"
                aria-hidden="true"></i><i class="fa fa-caret-right" aria-hidden="true"></i></a>
    </div>
</div>
<div class="agenda-details">
    <div *ngIf="currentAgenda && currentAgenda?.FinalUrl && showAgenda">
            <div id='pdf-div' style="width:100% !important; height: 50em;" class='pdf-view'></div>
    </div>
   
    <div class="content-holder" [hidden]="!hideAgenda">
        <div id='pdf-div-attach' style="width:100% !important; height: 50em;" class='pdf-view'></div>
    </div>
</div>
<div class="modal fade modal-size-medium" id="agendaPdfUploadDialogPSPFD" tabindex="-1" role="dialog"
    data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="width: 60%;margin: auto;">
            <div class="modal-header">
                <h5 class="modal-title">
                    <i class="fa fa-upload"></i>
                    <span id="AgendaPdfUploadTitlePSPDF"></span>
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <i class="fa fa-times"></i>
                </button>
            </div>
            <div class="modal-body" style="border:1px solid #ccc;">
                <div class="col-md-12">
                    <div class="row collapse1">
                        <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <td style="border-top:0px !important;"> <span
                                            style="padding:10px 15px;background: #d8ebeb;font-weight: 600;letter-spacing: 1px;display: inline-block;">
                                            {{agendaGenerationNumber}} </span> </td>
                                </tr>
                                <tr>
                                    <td style="border-top:0px !important;"> <a (click)="showCurrent()"
                                            href="javascript:void(0)" data-dismiss="modal"><span id="AgendaTitleOnPopup"
                                                style="font-weight: bold;"></span></a></td>
                                </tr>
                                <tr>
                                    <th>Filename</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let agenda of AgendaFile; let count=index">
                                    <td tabindex="1" style="width: 70%;">
                                        {{agenda.PdfName}}
                                    </td>
                                    <td>
                                        <button type="button" class="btn-sm btn btn-warning"
                                            (click)="downloadDocumentFile(agenda.DocumentManagementID,agenda.FileType)">
                                            <span title="View"
                                                *ngIf="agenda.FileType == 'PDF' || agenda.FileType == 'pdf' "
                                                class="fa fa-eye"></span>
                                            <span title="Download"
                                                *ngIf="agenda.FileType != 'PDF' && agenda.FileType != 'pdf' "
                                                class="fa fa-download"></span>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Voting Section -->
<div class="voting-section" style="margin-top: 20px; padding: 20px; background-color: #f8f9fa; border-radius: 8px;">
    <div class="voting-container">
        <h5 class="voting-heading" style="color: #333; font-weight: 600; margin-bottom: 15px; display: flex; align-items: center;">
            <i class="fa fa-thumbs-up" aria-hidden="true" style="margin-right: 10px; color: #37669e;"></i> Agenda Voting
        </h5>

        <!-- Loading State -->
        <div *ngIf="votingLoading" class="text-center" style="padding: 15px;">
            <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: #37669e;"></i>
            <p style="margin-top: 10px; color: #666;">Loading voting data...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="votingError && !votingLoading" class="alert alert-danger" style="margin-bottom: 15px;">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{votingError}}
        </div>

        <!-- Voting UI (for committee members only) -->
        <div *ngIf="!votingLoading && !votingError && canVote">
            <!-- Vote Buttons -->
            <div style="display: flex; gap: 10px; margin-bottom: 15px; flex-wrap: wrap;">
                <button 
                    type="button" 
                    class="btn"
                    [ngClass]="getUserVote()?.voteType === 'APPROVE' ? 'btn-success' : 'btn-outline-success'"
                    (click)="submitVote('APPROVE')"
                    title="Approve this agenda"
                    style="flex: 1; min-width: 150px; font-size: 14px; padding: 10px 20px; font-weight: 500; display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <span *ngIf="getUserVote()?.voteType === 'APPROVE'" style="font-weight: 600;">Approved</span>
                    <span *ngIf="getUserVote()?.voteType !== 'APPROVE'">Approve</span>
                </button>
                
                <button 
                    type="button" 
                    class="btn"
                    [ngClass]="getUserVote()?.voteType === 'REJECT' ? 'btn-danger' : 'btn-outline-danger'"
                    (click)="submitVote('REJECT')"
                    title="Reject this agenda"
                    style="flex: 1; min-width: 150px; font-size: 14px; padding: 10px 20px; font-weight: 500; display: flex; align-items: center; justify-content: center; gap: 8px;">
                    <i class="fa fa-times" aria-hidden="true"></i>
                    <span *ngIf="getUserVote()?.voteType === 'REJECT'" style="font-weight: 600;">Rejected</span>
                    <span *ngIf="getUserVote()?.voteType !== 'REJECT'">Reject</span>
                </button>
            </div>
            
            <!-- Vote Counts -->
            <div style="display: flex; justify-content: center; align-items: center; gap: 30px; padding: 15px; background-color: white; border-radius: 6px; margin-bottom: 10px;">
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #28a745;">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i> {{getVoteCounts().approveCount}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Approvals</div>
                </div>
                <div style="height: 40px; width: 1px; background-color: #dee2e6;"></div>
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #dc3545;">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i> {{getVoteCounts().rejectCount}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Rejections</div>
                </div>
                <div style="height: 40px; width: 1px; background-color: #dee2e6;"></div>
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #6c757d;">
                        {{getVoteCounts().totalVotes}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Total Votes</div>
                </div>
            </div>
            
            <!-- Retract Button (only shown if user has voted) -->
            <div *ngIf="hasUserVoted()" style="text-align: center; margin-top: 10px;">
                <button 
                    type="button" 
                    class="btn btn-sm btn-link"
                    (click)="retractVote()"
                    style="color: #007bff; text-decoration: underline; font-size: 13px;">
                    <i class="fa fa-undo" aria-hidden="true"></i> Retract Your Vote
                </button>
            </div>
        </div>

        <!-- Read-only voting display (for non-committee members) -->
        <div *ngIf="!votingLoading && !votingError && !canVote">
            <!-- Vote Counts (Read-only) -->
            <div style="display: flex; justify-content: center; align-items: center; gap: 30px; padding: 15px; background-color: white; border-radius: 6px; margin-bottom: 15px;">
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #28a745;">
                        <i class="fa fa-thumbs-up" aria-hidden="true"></i> {{getVoteCounts().approveCount}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Approvals</div>
                </div>
                <div style="height: 40px; width: 1px; background-color: #dee2e6;"></div>
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #dc3545;">
                        <i class="fa fa-thumbs-down" aria-hidden="true"></i> {{getVoteCounts().rejectCount}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Rejections</div>
                </div>
                <div style="height: 40px; width: 1px; background-color: #dee2e6;"></div>
                <div style="text-align: center;">
                    <div style="font-size: 24px; font-weight: 700; color: #6c757d;">
                        {{getVoteCounts().totalVotes}}
                    </div>
                    <div style="font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.5px;">Total Votes</div>
                </div>
            </div>

            <!-- Info message for non-committee members -->
            <div class="alert alert-info" style="margin-bottom: 0; font-size: 13px;">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
                Only Board Members and KMP can vote on agendas. You can view voting results above.
            </div>
        </div>
    </div>
</div>

<!-- Comment Section -->
<div class="comment-section" >
    <div class="comment-container">
        <h5 class="comment-heading">
            <i class="fa fa-comments" aria-hidden="true"></i> Comments
        </h5>
        
        <div class="comments-list" *ngIf="comments && comments.length > 0">
            <div class="comment-item" *ngFor="let comment of comments">
                <div class="comment-header" style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center; flex: 1;">
                        <span class="comment-author">{{comment.author || 'Anonymous'}}</span>
                        <!-- Debug info -->
                        
                        <div class="comment-actions" *ngIf="canPostComment && isCommentAuthor(comment)" style="margin-left: 10px; display: flex !important; align-items: center; gap: 8px; visibility: visible !important; opacity: 1 !important;">
                            <button 
                                type="button" 
                                class="btn btn-sm btn-link text-primary" 
                                (click)="startEditComment(comment)"
                                *ngIf="editingCommentId !== comment._id"
                                title="Edit comment"
                                style="padding: 4px 8px; border: none; background: none; cursor: pointer; display: inline-flex !important; align-items: center; visibility: visible !important; opacity: 1 !important; min-width: auto !important; width: auto !important;">
                                <i class="fa fa-edit" aria-hidden="true"></i>
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-sm btn-link text-danger" 
                                (click)="deleteComment(comment._id, comment)"
                                *ngIf="editingCommentId !== comment._id"
                                title="Delete comment"
                                style="padding: 4px 8px; border: none; background: none; cursor: pointer; display: inline-flex !important; align-items: center; visibility: visible !important; opacity: 1 !important; color: #dc3545 !important; min-width: auto !important; width: auto !important;">
                                <i class="fa fa-trash" aria-hidden="true" style="font-family: 'FontAwesome' !important; display: inline-block !important; visibility: visible !important; opacity: 1 !important;"></i>
                            </button>
                        </div>
                    </div>
                    <span class="comment-date" *ngIf="comment && comment.date" style="margin-left: auto;">{{comment.date | date:'short'}}</span>
                </div>
                <div class="comment-text" *ngIf="editingCommentId !== comment._id">{{comment.text}}</div>
                <div class="comment-edit-form" *ngIf="editingCommentId === comment._id">
                    <div class="form-group">
                        <textarea 
                            class="form-control comment-textarea" 
                            rows="3" 
                            [(ngModel)]="editCommentText"
                            name="editCommentText">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <button 
                            type="button" 
                            class="btn btn-sm btn-primary" 
                            (click)="saveEditComment()">
                            <i class="fa fa-save" aria-hidden="true"></i> Save
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-secondary" 
                            (click)="cancelEditComment()"
                            style="margin-left: 5px;">
                            <i class="fa fa-times" aria-hidden="true"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="add-comment-form" *ngIf="canPostComment">
            <div class="form-group">
                <textarea 
                    class="form-control comment-textarea" 
                    rows="4" 
                    placeholder="Add your comment here..."
                    [(ngModel)]="newComment"
                    name="newComment">
                </textarea>
            </div>
            <div class="form-group">
                <button 
                    type="button" 
                    class="btn btn-primary btn-sm" 
                    (click)="addComment()"
                    [disabled]="isCommentDisabled()">
                    <i class="fa fa-paper-plane" aria-hidden="true"></i> Post Comment
                </button>
            </div>
        </div>
        <div class="comment-info-message" *ngIf="!canPostComment && comments && comments.length > 0">
            <p class="small" style="color: #495057;">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
                Only Board Members and KMP can post comments. You can view comments above.
            </p>
        </div>
        <div class="comment-info-message" *ngIf="!canPostComment && (!comments || comments.length === 0)">
            <p class="small" style="color: #495057;">
                <i class="fa fa-info-circle" aria-hidden="true"></i> 
                Only Board Members and KMP can post comments.
            </p>
        </div>
    </div>
</div>